var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44 74.933594 L 366.75 74.933594 L 366.75 228 L 44 228 Z M 44 74.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258 113 L 366.75 113 L 366.75 156 L 258 156 Z M 258 113 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 258 185 L 366.75 185 L 366.75 246 L 258 246 Z M 258 185 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 120 L 366.75 120 L 366.75 284.183594 L 81 284.183594 Z M 81 120 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 75 L 66 75 L 66 284.183594 L 0 284.183594 Z M 0 75 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 81.378906 74.933594 L 81.378906 83.742188 L 114.027344 83.773438 L 84.984375 193.722656 L 53.507812 75.03125 L 44.5 75.03125 C 44.609375 75.417969 85.007812 227.652344 85.007812 227.652344 L 123.007812 83.789062 L 157.496094 83.824219 L 195.488281 227.652344 L 233.621094 83.878906 C 263.304688 83.832031 364.148438 83.664062 366.609375 83.671875 L 366.609375 74.933594 Z M 166.472656 83.832031 L 224.625 83.894531 L 195.496094 193.726562 Z M 166.472656 83.832031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 357.921875 113.777344 L 258.757812 113.777344 L 258.757812 155.417969 L 332.605469 155.417969 C 332.605469 155.417969 340.074219 155.464844 341.289062 155.238281 L 341.289062 146.746094 L 267.4375 146.746094 L 267.4375 122.445312 L 366.601562 122.445312 L 366.601562 113.851562 C 362.832031 113.621094 357.921875 113.777344 357.921875 113.777344 Z M 357.921875 113.777344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 267.4375 193.976562 L 341.289062 193.976562 L 341.289062 185.335938 C 339.261719 185.167969 332.605469 185.304688 332.605469 185.304688 L 258.757812 185.304688 L 258.757812 245.664062 L 357.921875 245.664062 C 357.921875 245.664062 363.414062 245.691406 366.601562 245.5625 L 366.601562 236.992188 L 267.4375 236.992188 Z M 267.4375 193.976562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 357.921875 275.550781 L 226.984375 275.550781 C 224.300781 275.457031 217.753906 275.496094 217.753906 275.496094 L 182.027344 275.496094 L 140.246094 120.992188 L 98.460938 275.496094 C 98.460938 275.496094 98.445312 275.574219 98.40625 275.714844 C 88.691406 275.734375 82.402344 275.757812 81.960938 275.773438 L 81.960938 284.210938 L 366.601562 284.210938 L 366.601562 275.480469 C 362.832031 275.75 357.921875 275.550781 357.921875 275.550781 Z M 140.246094 154.242188 L 173.070312 275.613281 C 150.679688 275.636719 125.578125 275.675781 107.398438 275.707031 Z M 140.246094 154.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 11.484375 83.703125 C 11.484375 83.703125 9.804688 77.953125 9.085938 75.03125 L 0.179688 75.03125 L 56.066406 284.175781 L 65.042969 284.175781 C 63.941406 280.667969 62.734375 275.503906 62.734375 275.503906 Z M 11.484375 83.703125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeLogo);
export default __webpack_public_path__ + "static/media/we-logo.4157da61df680a5f95f8f0f6d10194e8.svg";
export { ForwardRef as ReactComponent };